import { render, staticRenderFns } from "./sort-edit.vue?vue&type=template&id=37e16ed6&scoped=true&"
import script from "./sort-edit.vue?vue&type=script&lang=js&"
export * from "./sort-edit.vue?vue&type=script&lang=js&"
import style0 from "./sort-edit.vue?vue&type=style&index=0&id=37e16ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e16ed6",
  null
  
)

export default component.exports